import { Link } from "react-router-dom";
import { Session } from "@supabase/supabase-js";

interface FooterProps {
  profile?: any;
  session?: Session;
}

export const Footer = ({ profile, session }: FooterProps) => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        {!session && (<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">About</h3>
            <ul className="space-y-2">
              <li><Link to="/about/company" className="hover:text-primary">Company</Link></li>
              <li><Link to="/about/team" className="hover:text-primary">Team</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><a href="https://blog.causeconnect.ai/" target="_blank" rel="noopener noreferrer" className="hover:text-primary">Blog</a></li>
              <li><Link to="/help/faq" className="hover:text-primary">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-primary">Contact</Link></li>
              <li><Link to="/legal/terms" className="hover:text-primary">Terms of Service</Link></li>
              <li><Link to="/legal/privacy" className="hover:text-primary">Privacy Policy</Link></li>
              <li><Link to="/events/great-india-volunteering-festival-tgivf-2025" className="hover:text-primary font-semibold">GIVF</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              Solutions
            </h3>
            <ul role="list" className="mt-4 space-y-4">
              <li>
                <Link to="/solutions/community-volunteering" className="text-base text-gray-300 hover:text-white">
                  Community Volunteering
                </Link>
              </li>
              <li>
                <Link to="/solutions/mission-hub" className="text-base text-gray-300 hover:text-white">
                  Mission Hub
                </Link>
              </li>
              <li>
                <Link to="/solutions/ai-assistant" className="text-base text-gray-300 hover:text-white">
                  AI Assistant
                </Link>
              </li>
              <li>
                <Link to="/solutions/ai-growth-engine" className="text-base text-gray-300 hover:text-white">
                  AI Growth Engine
                </Link>
              </li>
            </ul>
          </div>
        </div>)}
        
        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} CauseConnect Pte. Ltd. All rights reserved.</p>
          <p className="text-xs text-gray-500 mt-1">68 Circular Road, #02-01, Singapore 049422</p>
        </div>
      </div>
    </footer>
  );
};
